import React, { useEffect, useState } from 'react';
import { api } from '../services/apiV2';
import { Icon } from './icons';
import { Field, PrimaryButton } from './common';

const primeiroNome = (nome: string) => String(nome || '').trim().split(/\s+/)[0] || '';

const AuthShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="scroll" style={{
    paddingBottom: 40, background: 'var(--paper)',
    minHeight: '100vh', position: 'relative',
  }}>
    <div style={{ position: 'absolute', top: 40, left: 24, display: 'flex', alignItems: 'center', gap: 8 }}>
      <img src="/icons/forjamente-icon.png" alt="" width={22} height={22} style={{ borderRadius: 5 }}/>
      <div className="mono" style={{
        fontSize: 10, letterSpacing: '0.22em', textTransform: 'uppercase',
        color: 'var(--ink-2)',
      }}>Forjamente</div>
    </div>
    {children}
  </div>
);

export interface AuthPayload {
  email: string;
  password?: string;
  name?: string;
  wpp?: string;
}

export const LoginScreen: React.FC<{
  onLogin: (p: AuthPayload) => void | Promise<void>;
  onGoRegister: () => void;
  onGoForgot: () => void;
  initialEmail?: string;
  errorMessage?: string | null;
  loading?: boolean;
}> = ({ onLogin, onGoRegister, onGoForgot, initialEmail, errorMessage, loading }) => {
  const [email, setEmail] = useState(initialEmail || '');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const valid = /.+@.+\..+/.test(email) && password.length >= 4;
  return (
    <AuthShell>
      <div style={{ padding: '110px 24px 0' }}>
        <div className="serif" style={{ fontSize: 44, lineHeight: 1, letterSpacing: '-0.02em' }}>
          Bem-vindo<br/>
          <span style={{ fontStyle: 'italic', color: 'var(--ember)' }}>de volta</span>.
        </div>
        <div style={{ fontSize: 14, color: 'var(--ink-3)', marginTop: 10, maxWidth: 280 }}>
          Seu hábito continua onde você parou.
        </div>
      </div>
      <div style={{ padding: '40px 24px 0', display: 'flex', flexDirection: 'column', gap: 28 }}>
        <Field label="E-mail" value={email} onChange={setEmail} type="email" placeholder="voce@dominio.com" icon="user" autoFocus inputMode="email"/>
        <div style={{ position: 'relative' }}>
          <Field label="Senha" value={password} onChange={setPassword} type={show ? 'text' : 'password'} placeholder="********" icon="lock"/>
          <button onClick={() => setShow(s => !s)} style={{
            position: 'absolute', right: 0, bottom: 10,
            background: 'transparent', fontSize: 11, color: 'var(--ink-3)',
            fontFamily: 'Geist Mono, monospace', letterSpacing: '0.1em', textTransform: 'uppercase',
          }}>{show ? 'ocultar' : 'mostrar'}</button>
        </div>
        <div style={{ textAlign: 'right', marginTop: -12 }}>
          <button onClick={onGoForgot} style={{
            background: 'transparent', color: 'var(--ink-2)',
            fontSize: 13.5, fontFamily: "Geist, Geist Fallback, -apple-system, system-ui, sans-serif",
            textDecoration: 'underline', textDecorationColor: 'var(--ember)', textUnderlineOffset: 4,
          }}>Esqueceu a senha?</button>
        </div>

        {errorMessage && (
          <div style={{
            padding: '12px 14px', borderRadius: 12,
            background: 'rgba(232,122,59,0.12)', color: 'var(--ember)',
            fontSize: 13, textAlign: 'center',
          }}>{errorMessage}</div>
        )}

        <div style={{ marginTop: 8 }}>
          <PrimaryButton onClick={() => valid && !loading && onLogin({ email, password })} disabled={!valid || !!loading}>
            {loading ? 'Entrando...' : 'Entrar'}
            {!loading && <Icon name="arrow-right" size={14} color="currentColor" stroke={2.2}/>}
          </PrimaryButton>
        </div>
      </div>

      <div style={{ padding: '40px 24px 0', display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ flex: 1, height: 1, background: 'var(--line)' }}/>
        <div className="mono" style={{ fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--ink-4)' }}>ou</div>
        <div style={{ flex: 1, height: 1, background: 'var(--line)' }}/>
      </div>
      <div style={{ padding: '24px 24px 0', textAlign: 'center' }}>
        <div style={{ fontSize: 14, color: 'var(--ink-2)' }}>
          Primeira vez por aqui?{' '}
          <button onClick={onGoRegister} style={{
            background: 'transparent', fontFamily: "Geist, Geist Fallback, -apple-system, system-ui, sans-serif",
            fontSize: 17, fontStyle: 'italic', color: 'var(--ember)', marginLeft: 4,
          }}>Criar conta</button>
        </div>
      </div>
    </AuthShell>
  );
};

// Veio da página de um Mentor (Círculo): o cadastro fala do Círculo dele.
export interface CirculoNoCadastro { mentorNome: string; assinar: boolean }

export const RegisterScreen: React.FC<{
  onRegister: (p: AuthPayload) => void | Promise<void>;
  onGoLogin: () => void;
  errorMessage?: string | null;
  loading?: boolean;
  circulo?: CirculoNoCadastro | null;
}> = ({ onRegister, onGoLogin, errorMessage, loading, circulo }) => {
  const [form, setForm] = useState({ name: '', email: '', wpp: '', password: '' });
  const [show, setShow] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  // O APP PAGO (01/11/2026): o fim do cadastro diz a oferta — N dias grátis,
  // sem cartão. Só quando o servidor diz que está no ar (PAYWALL_DURO e a
  // interface nova para as contas novas); fora do Círculo, que tem a sua.
  // Só assinantes (02/11/2026, noite): sem teste, a linha diz a garantia e
  // que a assinatura vem logo depois, na loja.
  const [diasGratis, setDiasGratis] = useState<number | null>(null);
  const [garantia, setGarantia] = useState<number | null>(null);
  useEffect(() => {
    if (circulo) return;
    let vivo = true;
    api.oferta().then((o) => {
      if (!vivo) return;
      if (o?.teste_gratis) setDiasGratis(o.teste_dias ?? 7);
      else if (o?.modelo === 'assinatura') setGarantia(o.garantia_dias ?? 7);
    }).catch(() => {});
    return () => { vivo = false; };
  }, [circulo]);
  const set = (k: string, v: string) => setForm(f => ({ ...f, [k]: v }));
  const maskWpp = (raw: string) => {
    const d = raw.replace(/\D/g, '').slice(0, 11);
    if (d.length <= 2) return d;
    if (d.length <= 7) return `(${d.slice(0,2)}) ${d.slice(2)}`;
    return `(${d.slice(0,2)}) ${d.slice(2,7)}-${d.slice(7)}`;
  };
  const validName = form.name.trim().length >= 2;
  const validEmail = /.+@.+\..+/.test(form.email);
  const validWpp = form.wpp.trim() === '' || form.wpp.replace(/\D/g, '').length >= 10;
  const validPw = REGRA_SENHA.ok(form.password);
  const valid = validName && validEmail && validWpp && validPw && acceptedTerms;
  return (
    <AuthShell>
      <div style={{ padding: '110px 24px 0' }}>
        {circulo && (
          <div className="mono" data-cadastro-circulo="" style={{
            fontSize: 10.5, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 12,
          }}>Círculo de {primeiroNome(circulo.mentorNome)}</div>
        )}
        <div className="serif" style={{ fontSize: 44, lineHeight: 1, letterSpacing: '-0.02em' }}>
          {garantia != null ? <>Crie a sua<br/></> : <>Comece seu<br/></>}
          <span style={{ fontStyle: 'italic', color: 'var(--ember)' }}>{garantia != null ? 'conta' : 'hábito'}</span>.
        </div>
        <div data-cadastro-linha="" style={{ fontSize: 14, color: 'var(--ink-3)', marginTop: 10, maxWidth: 300 }}>
          {circulo
            ? (circulo.assinar
              ? `A conta é grátis. Em seguida você volta ao Círculo de ${primeiroNome(circulo.mentorNome)} e assina pelo app em 1 toque.`
              : `A conta é grátis. Em seguida você volta ao Círculo de ${primeiroNome(circulo.mentorNome)}.`)
            : garantia != null
              ? 'Nome, e-mail e senha. Sem código por e-mail: você entra na hora.'
              : 'Algumas páginas por dia viram constância, e constância vira centenas de livros ao longo dos anos.'}
        </div>
      </div>
      <div style={{ padding: '40px 24px 0', display: 'flex', flexDirection: 'column', gap: 24 }}>
        <Field label="Como quer ser chamado" value={form.name} onChange={v => set('name', v)} placeholder="Seu nome" icon="user" autoFocus/>
        <Field label="E-mail" value={form.email} onChange={v => set('email', v)} type="email" placeholder="voce@dominio.com" icon="mail" inputMode="email"/>
        <Field label="WhatsApp (opcional)" value={form.wpp} onChange={v => set('wpp', maskWpp(v))} placeholder="(11) 91234-5678" icon="phone" inputMode="tel"/>
        <div style={{ position: 'relative' }}>
          <Field label="Senha" value={form.password} onChange={v => set('password', v)} type={show ? 'text' : 'password'} placeholder="8 caracteres, com letra e número" icon="lock"/>
          <RequisitosSenha valor={form.password} />
          <button onClick={() => setShow(s => !s)} style={{
            position: 'absolute', right: 0, bottom: 10,
            background: 'transparent', fontSize: 11, color: 'var(--ink-3)',
            fontFamily: 'Geist Mono, monospace', letterSpacing: '0.1em', textTransform: 'uppercase',
          }}>{show ? 'ocultar' : 'mostrar'}</button>
        </div>

        {errorMessage && (
          <div style={{
            padding: '12px 14px', borderRadius: 12,
            background: 'rgba(232,122,59,0.12)', color: 'var(--ember)',
            fontSize: 13, textAlign: 'center',
          }}>{errorMessage}</div>
        )}

        <label style={{
          display: 'flex', alignItems: 'flex-start', gap: 10,
          cursor: 'pointer', userSelect: 'none',
          marginTop: 4,
        }}>
          <input
            type="checkbox"
            checked={acceptedTerms}
            onChange={e => setAcceptedTerms(e.target.checked)}
            className="caixa-aceite"
          />
          <span style={{ fontSize: 12.5, color: 'var(--ink-2)', lineHeight: 1.5 }}>
            Li e aceito os{' '}
            <a href="/termos" target="_blank" rel="noopener noreferrer"
              style={{ color: 'var(--ember)', textDecoration: 'underline' }}>
              Termos de Uso
            </a>{' '}e a{' '}
            <a href="/privacidade" target="_blank" rel="noopener noreferrer"
              style={{ color: 'var(--ember)', textDecoration: 'underline' }}>
              Política de Privacidade
            </a>
            .
          </span>
        </label>

        {(diasGratis != null || garantia != null) && (
          <div data-cadastro-oferta={garantia != null ? 'assinatura' : 'teste'} style={{ marginTop: 8, fontSize: 13.5, fontWeight: 600, color: 'var(--ember)', textAlign: 'center' }}>
            {garantia != null
              ? `R$ 29,90 por ano · ${garantia} dias de garantia. Em seguida, você assina pela App Store ou pelo Google Play.`
              : `${diasGratis} dias grátis, sem cartão. Depois, R$ 29,90 por ano.`}
          </div>
        )}
        <div style={{ marginTop: diasGratis != null || garantia != null ? 0 : 16 }}>
          <PrimaryButton onClick={() => valid && !loading && onRegister({ name: form.name.trim(), email: form.email, wpp: form.wpp, password: form.password })} disabled={!valid || !!loading}>
            {loading ? 'Enviando...' : 'Criar conta'}
            {!loading && <Icon name="arrow-right" size={14} color="currentColor" stroke={2.2}/>}
          </PrimaryButton>
        </div>
      </div>
      <div style={{ padding: '40px 24px 0', textAlign: 'center' }}>
        <div style={{ fontSize: 14, color: 'var(--ink-2)' }}>
          Já tem conta?{' '}
          <button onClick={onGoLogin} style={{
            background: 'transparent', fontFamily: "Geist, Geist Fallback, -apple-system, system-ui, sans-serif",
            fontSize: 17, fontStyle: 'italic', color: 'var(--ember)', marginLeft: 4,
          }}>Entrar</button>
        </div>
      </div>
    </AuthShell>
  );
};

export const ForgotScreen: React.FC<{
  onBack: () => void;
  onSubmit: (email: string) => Promise<void>;
  loading?: boolean;
}> = ({ onBack, onSubmit, loading }) => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const valid = /.+@.+\..+/.test(email);
  const submit = async () => {
    if (!valid || loading) return;
    try {
      await onSubmit(email);
      setSent(true);
    } catch (e: any) {
      setError(e.message || 'Erro ao enviar');
    }
  };
  return (
    <AuthShell>
      <button onClick={onBack} style={{
        position: 'absolute', top: 40, right: 20,
        width: 38, height: 38, borderRadius: '50%',
        background: 'var(--paper-2)', border: '1px solid var(--line)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}><Icon name="close" size={16}/></button>

      <div style={{ padding: '110px 24px 0' }}>
        {!sent ? (<>
          <div className="serif" style={{ fontSize: 44, lineHeight: 1, letterSpacing: '-0.02em' }}>
            Recuperar<br/>
            <span style={{ fontStyle: 'italic', color: 'var(--ember)' }}>acesso</span>.
          </div>
          <div style={{ fontSize: 14, color: 'var(--ink-3)', marginTop: 10, maxWidth: 290 }}>
            Digite o e-mail da sua conta. Enviaremos um link para você definir uma nova senha.
          </div>
          <div style={{ marginTop: 40, display: 'flex', flexDirection: 'column', gap: 28 }}>
            <Field label="E-mail" value={email} onChange={setEmail} type="email" placeholder="voce@dominio.com" icon="mail" autoFocus inputMode="email"/>
            {error && <div style={{ padding: '10px 14px', borderRadius: 12, background: 'rgba(232,122,59,0.12)', color: 'var(--ember)', fontSize: 13, textAlign: 'center' }}>{error}</div>}
            <PrimaryButton onClick={submit} disabled={!valid || !!loading}>
              {loading ? 'Enviando...' : 'Enviar link'}
              {!loading && <Icon name="arrow-right" size={14} color="currentColor" stroke={2.2}/>}
            </PrimaryButton>
          </div>
          <div style={{ marginTop: 32, textAlign: 'center' }}>
            <button onClick={onBack} style={{
              background: 'transparent', color: 'var(--ink-2)',
              fontSize: 14, fontFamily: "Geist, Geist Fallback, -apple-system, system-ui, sans-serif",
            }}>Lembrei, voltar ao login</button>
          </div>
        </>) : (
          <div style={{ textAlign: 'center', paddingTop: 40 }}>
            <div style={{
              width: 80, height: 80, margin: '0 auto',
              borderRadius: '50%', background: 'var(--ember-soft)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <Icon name="mail" size={36} color="var(--ember)" stroke={1.6}/>
            </div>
            {/* Esta tela dizia "Link enviado." como afirmação. Ela NÃO pode
                afirmar isso: o servidor responde igual tendo conta ou não, de
                propósito — dizer "esse e-mail não existe" entregaria a
                estranhos quem tem conta aqui.
                O problema é que a certeza falsa custou caro. Em 02/09/2026 uma
                leitora sem conta leu "Link enviado", esperou dias por um e-mail
                que jamais existiria, e desistiu achando que o app estava
                quebrado.
                O sigilo continua — o que muda é a pessoa saber o que fazer
                quando nada chega. */}
            <div className="serif" style={{ fontSize: 34, lineHeight: 1.05, marginTop: 24, letterSpacing: '-0.01em' }}>
              Confira seu <span style={{ fontStyle: 'italic', color: 'var(--ember)' }}>e-mail</span>.
            </div>
            <div style={{ fontSize: 14, color: 'var(--ink-3)', marginTop: 10, maxWidth: 290, marginLeft: 'auto', marginRight: 'auto' }}>
              Se existe uma conta com <strong style={{ color: 'var(--ink)' }}>{email}</strong>, o link já saiu. Ele expira em 30 minutos.
            </div>
            <div style={{ fontSize: 13, color: 'var(--ink-3)', marginTop: 8, maxWidth: 300, marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.45 }}>
              Não achou? Procure na <strong style={{ color: 'var(--ink)' }}>caixa de spam</strong> ou na aba de promoções.
            </div>
            <div style={{ fontSize: 13, color: 'var(--ink-3)', marginTop: 18, maxWidth: 300, marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.5, padding: '12px 14px', borderRadius: 12, background: 'var(--paper-2)', border: '1px solid var(--line)' }}>
              Passaram alguns minutos e não chegou nada? Provavelmente <strong style={{ color: 'var(--ink)' }}>não existe conta com esse e-mail</strong> — nesse caso é só criar uma.
              <button onClick={onBack} style={{ display: 'block', margin: '10px auto 0', background: 'transparent', color: 'var(--ember)', fontSize: 13.5, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
                Criar minha conta
              </button>
            </div>
          </div>
        )}
      </div>
    </AuthShell>
  );
};

export const ResetPasswordScreen: React.FC<{
  token: string;
  onDone: () => void;
}> = ({ token, onDone }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const valid = REGRA_SENHA.ok(password) && password === confirm;
  const submit = async () => {
    if (!valid || loading) return;
    setLoading(true); setError(null);
    try {
      const r = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error((data as any).error || 'Falha ao redefinir');
      setDone(true);
      setTimeout(() => onDone(), 2000);
    } catch (e: any) {
      setError(e.message || 'Erro');
    } finally {
      setLoading(false);
    }
  };
  return (
    <AuthShell>
      <div style={{ padding: '110px 24px 0' }}>
        {!done ? <>
          <div className="serif" style={{ fontSize: 44, lineHeight: 1, letterSpacing: '-0.02em' }}>
            Nova<br/>
            <span style={{ fontStyle: 'italic', color: 'var(--ember)' }}>senha</span>.
          </div>
          <div style={{ fontSize: 14, color: 'var(--ink-3)', marginTop: 10, maxWidth: 290 }}>
            Escolha uma senha com 8 caracteres, incluindo uma letra e um número.
          </div>
          <div style={{ marginTop: 40, display: 'flex', flexDirection: 'column', gap: 28 }}>
            <div style={{ position: 'relative' }}>
              <Field label="Nova senha" value={password} onChange={setPassword} type={show ? 'text' : 'password'} placeholder="8 caracteres, com letra e número" icon="lock" autoFocus/>
              <RequisitosSenha valor={password} />
              <button onClick={() => setShow(s => !s)} style={{
                position: 'absolute', right: 0, bottom: 10, background: 'transparent',
                fontSize: 11, color: 'var(--ink-3)', fontFamily: 'Geist Mono, monospace',
                letterSpacing: '0.1em', textTransform: 'uppercase',
              }}>{show ? 'ocultar' : 'mostrar'}</button>
            </div>
            <Field label="Confirmar" value={confirm} onChange={setConfirm} type={show ? 'text' : 'password'} placeholder="repita a senha" icon="lock"/>
            {error && (
              <div style={{ padding: '10px 14px', borderRadius: 12, background: 'rgba(232,122,59,0.12)', color: 'var(--ember)', fontSize: 13, textAlign: 'center' }}>{error}</div>
            )}
            <PrimaryButton onClick={submit} disabled={!valid || loading}>
              {loading ? 'Salvando...' : 'Redefinir senha'}
              {!loading && <Icon name="arrow-right" size={14} color="currentColor" stroke={2.2}/>}
            </PrimaryButton>
          </div>
        </> : (
          <div style={{ textAlign: 'center', paddingTop: 40 }}>
            <div style={{
              width: 80, height: 80, margin: '0 auto',
              borderRadius: '50%', background: 'var(--ember-soft)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}><Icon name="check" size={36} color="var(--ember)" stroke={2}/></div>
            <div className="serif" style={{ fontSize: 34, lineHeight: 1.05, marginTop: 24 }}>
              Senha <span style={{ fontStyle: 'italic', color: 'var(--ember)' }}>redefinida</span>.
            </div>
            <div style={{ fontSize: 14, color: 'var(--ink-3)', marginTop: 10 }}>
              Abrindo o login...
            </div>
          </div>
        )}
      </div>
    </AuthShell>
  );
};

/* ── A regra da senha, em UM lugar ─────────────────────────────────────────
   Espelha validateSignupInput() do server.js. Quando as duas divergem, quem
   paga e a pessoa no cadastro: a tela libera o botao, o servidor recusa, e ela
   descobre a regra real por tentativa e erro. */
const REGRA_SENHA = {
  minimo: 8,
  testar: (v: string) => ({
    tamanho: (v || '').length >= 8,
    letra: /[a-zA-Z]/.test(v || ''),
    numero: /[0-9]/.test(v || ''),
  }),
  ok: (v: string) => {
    const r = REGRA_SENHA.testar(v);
    return r.tamanho && r.letra && r.numero;
  },
};

/** Mostra o que falta ENQUANTO a pessoa digita, em vez de recusar depois. */
const RequisitosSenha: React.FC<{ valor: string }> = ({ valor }) => {
  const r = REGRA_SENHA.testar(valor);
  const itens: Array<[boolean, string]> = [
    [r.tamanho, '8 caracteres'],
    [r.letra, 'uma letra'],
    [r.numero, 'um número'],
  ];
  return (
    <div style={{
      display: 'flex', flexWrap: 'wrap', gap: '6px 14px', marginTop: 9,
    }}>
      {itens.map(([feito, texto], i) => (
        <span key={i} style={{
          display: 'inline-flex', alignItems: 'center', gap: 5,
          fontSize: 12.5, lineHeight: 1.3,
          color: feito ? 'var(--ember)' : 'var(--ink-4)',
          transition: 'color .2s',
        }}>
          <span style={{
            width: 5, height: 5, borderRadius: '50%', flexShrink: 0,
            background: feito ? 'var(--ember)' : 'var(--ink-4)',
            opacity: feito ? 1 : 0.5, transition: 'background .2s, opacity .2s',
          }} />
          {texto}
        </span>
      ))}
    </div>
  );
};

export const AuthFlow: React.FC<{
  onLogin: (p: AuthPayload) => Promise<void>;
  onRegister: (p: AuthPayload) => Promise<void>;
  onForgot: (email: string) => Promise<void>;
  initialEmail?: string;
  initialView?: 'login' | 'register';
  errorMessage?: string | null;
  loading?: boolean;
  circulo?: CirculoNoCadastro | null;
}> = ({ onLogin, onRegister, onForgot, initialEmail, initialView, errorMessage, loading, circulo }) => {
  const [view, setView] = useState<'login' | 'register' | 'forgot'>(initialView || 'login');
  if (view === 'register') return <RegisterScreen onRegister={onRegister} onGoLogin={() => setView('login')} errorMessage={errorMessage} loading={loading} circulo={circulo}/>;
  if (view === 'forgot') return <ForgotScreen onBack={() => setView('login')} onSubmit={onForgot} loading={loading}/>;
  return <LoginScreen onLogin={onLogin} onGoRegister={() => setView('register')} onGoForgot={() => setView('forgot')} initialEmail={initialEmail} errorMessage={errorMessage} loading={loading}/>;
};
